import noop from '../args/noop';
import {windows} from "../sysenv/windowsimulate";
export default function removeConsole(clear) {
  try {
    if (!windows.console) windows.console = {};
    windows.console.log = windows.console.info = windows.console.dir = windows.console.warn = windows.console.trace = noop;
    if (clear === 'clear' && windows.console.clear) windows.console.clear();
  } catch (e) {}
}
